var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 180,
    viewBox: "0 0 186 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 95.5,
    cy: 90.5,
    r: 70.5,
    fill: "url(#paint0_linear_192_4341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.7575 68H105.265C112.892 68 118 73.355 118 81.32V99.7048C118 107.645 112.892 113 105.265 113H85.7575C78.13 113 73 107.645 73 99.7048V81.32C73 73.355 78.13 68 85.7575 68ZM103.716 83.7141L97.4158 90.0041L103.716 96.2941C103.81 96.3871 103.884 96.4977 103.935 96.6195C103.985 96.7414 104.012 96.8721 104.012 97.0041C104.012 97.1361 103.985 97.2668 103.935 97.3887C103.884 97.5105 103.81 97.6211 103.716 97.7141C103.623 97.8078 103.512 97.8822 103.39 97.933C103.269 97.9838 103.138 98.0099 103.006 98.0099C102.874 98.0099 102.743 97.9838 102.621 97.933C102.499 97.8822 102.389 97.8078 102.296 97.7141L96.0058 91.4141L89.7158 97.7141C89.6228 97.8078 89.5122 97.8822 89.3904 97.933C89.2685 97.9838 89.1378 98.0099 89.0058 98.0099C88.8738 98.0099 88.7431 97.9838 88.6212 97.933C88.4994 97.8822 88.3888 97.8078 88.2958 97.7141C88.2021 97.6211 88.1277 97.5105 88.0769 97.3887C88.0261 97.2668 88 97.1361 88 97.0041C88 96.8721 88.0261 96.7414 88.0769 96.6195C88.1277 96.4977 88.2021 96.3871 88.2958 96.2941L94.5958 90.0041L88.2958 83.7141C88.1075 83.5258 88.0017 83.2704 88.0017 83.0041C88.0017 82.7378 88.1075 82.4824 88.2958 82.2941C88.4841 82.1058 88.7395 82 89.0058 82C89.2721 82 89.5275 82.1058 89.7158 82.2941L96.0058 88.5941L102.296 82.2941C102.484 82.1058 102.739 82 103.006 82C103.272 82 103.527 82.1058 103.716 82.2941C103.904 82.4824 104.01 82.7378 104.01 83.0041C104.01 83.2704 103.904 83.5258 103.716 83.7141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    cx: 178.461,
    cy: 27.5,
    r: 7.5,
    fill: "#A592FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    cx: 20.0312,
    cy: 10,
    r: 10,
    fill: "#A592FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    cx: 10.0312,
    cy: 133,
    r: 5,
    fill: "#A592FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    cx: 165.531,
    cy: 160.5,
    r: 2.5,
    fill: "#A592FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    cx: 106.531,
    cy: 4.5,
    r: 2.5,
    fill: "#A592FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    cx: 62.5312,
    cy: 176.5,
    r: 3.5,
    fill: "#A592FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    cx: 122.031,
    cy: 171,
    r: 1,
    fill: "#A592FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    cx: 170.531,
    cy: 110.5,
    r: 2.5,
    fill: "#A592FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    cx: 1.03125,
    cy: 75,
    r: 1,
    fill: "#A592FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_192_4341",
    x1: 166,
    y1: 161,
    x2: -1.77734,
    y2: 112.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6949FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#876DFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossGroup);
export default __webpack_public_path__ + "static/media/crossGroup.c19fcf24b1e55a8f9fe96d45149e2ee4.svg";
export { ForwardRef as ReactComponent };